import type { GroupAnalysis } from '@cli-types/next-adapter/forms.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderBuildGroupFieldArrayHooksFieldArrayTemplate } from '@next-adapter/templates/renderers/generators/form/form-single/build-group-field-array-hooks.js'

export function buildGroupFieldArrayHooks(analysis: GroupAnalysis): string {
  return analysis.listFieldsWithNested
    .map((field) => {
      const pascalFieldName = toPascalCase(field.name)
      return renderBuildGroupFieldArrayHooksFieldArrayTemplate({
        fieldName: field.name,
        pascalFieldName: pascalFieldName
      })
    })
    .join('\n')
}
